// extracted by mini-css-extract-plugin
export default {"tag":"KdevTag__tag___cQeoQ"};